/**
 * Formats message content for moderation display, cleaning up
 * shared challenge/post/community links and HTML tags so raw code
 * is not shown in tables and preview drawers.
 */
export const formatModerationMessage = (msg) => {
    if (!msg || typeof msg !== "string") return msg || "";

    // 1. Shared Challenge
    if (msg.includes("handleSharedChallengeClick")) {
        const textMatch = msg.match(/>\s*([^<]+)<\/a>/i);
        if (textMatch && textMatch[1]) {
            let label = textMatch[1].trim();
            // Remove "View Challenge:" prefix if present
            label = label.replace(/^View Challenge:\s*/i, "").trim();
            // If the label is just the word "Challenge" or empty, show "🏆 Shared Challenge"
            if (!label || label.toLowerCase() === "challenge") {
                return "Shared Challenge";
            }
            return `Challenge: ${label}`;
        }
        return "Shared Challenge";
    }

    // 2. Shared Community Post
    if (msg.includes("handleSharedCommunityPostClick")) {
        const textMatch = msg.match(/>\s*([^<]+)<\/a>/i);
        if (textMatch && textMatch[1]) {
            return `👥 ${textMatch[1].trim()}`;
        }
        return "👥 Shared Community Post";
    }

    // 3. Shared Regular Post
    if (msg.includes("handleSharedPostClick")) {
        const textMatch = msg.match(/>\s*([^<]+)<\/a>/i);
        if (textMatch && textMatch[1]) {
            return `🔗 ${textMatch[1].trim()}`;
        }
        return "🔗 Shared Post";
    }

    // 4. Any other HTML link or tags -> extract inner text if an <a> tag exists
    if (msg.includes("<a ") || msg.includes("<A ")) {
        const textMatch = msg.match(/<a[^>]*>(.*?)<\/a>/i);
        if (textMatch && textMatch[1]) {
            const strippedInner = textMatch[1].replace(/<[^>]*>/g, "").trim();
            if (strippedInner) return strippedInner;
        }
    }

    // 5. Strip any leftover HTML tags
    if (msg.includes("<") && msg.includes(">")) {
        const stripped = msg.replace(/<[^>]*>/g, "").trim();
        return stripped || msg;
    }

    return msg;
};
